function addClassesOnIntersection(elementsList, class1, class2) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio >= 0.010) {
        entry.target.classList.add(class1, class2);
      } 
    });
  });
  
  elementsList.forEach(element => {
    observer.observe(element);
  });
}


document.addEventListener("DOMContentLoaded", () => {
  const cards = [...document.querySelectorAll('.js-card')];

  function addClassesOnMouseOver(elements, classes) {
    elements.forEach(element => {
      element.addEventListener('mouseover', () => {
        // Add classes to the current element
        element.classList.add(...classes);
        // Remove classes from all other elements
        const otherElements = document.getElementsByClassName(element.className);
        for (let i = 0; i < otherElements.length; i++) {
          if (otherElements[i] !== element) {
            otherElements[i].classList.remove(...classes);
          }
        }
      });
    });
  }

  addClassesOnMouseOver(cards, ['tw-active-card', 'active-card']);

  if (window.innerWidth < 1280) {
    addClassesOnIntersection(cards, 'tw-active-card','active-card');
  }



  if(document.querySelector('#title-intro-home')){
    const splitLines = new SplitText(".gsap-line", { type: "lines" });
    gsap.set(splitLines.lines, { y: "100%", opacity: 0 });
    gsap.to(splitLines.lines, { 
        duration: 0.7,
        y: "0%",
        opacity: 1,
        ease: "power2.out",
        stagger: 0.08,
        delay: 2.2
      },
    );

    const split = new SplitText(".gsap-char");
    gsap.set(split.chars, { y: "100", opacity: 0 });
    gsap.to(split.chars, { 
        duration: 1.5,
        y: "0",
        opacity: 1,
        ease: "power2.out",
        stagger: 0.08        
      },
    );
    
    let svgInto = gsap.timeline();
    let titleIntroPart1 = gsap.timeline();
    let titleIntroPart2 = gsap.timeline();
    let article = gsap.timeline();
    let event = gsap.timeline();
    let podcast = gsap.timeline();

    svgInto.fromTo(".gsap-title svg path.cage", 
    {y: "0", opacity: 0, scaleX: 0},
    { 
      duration: 1,
      y: "0",
      opacity: 1,
      scaleX: 1,
      ease: "power2.out",
      stagger: 0.08       
    });

    titleIntroPart1.fromTo(".gsap-title h1.title .title-part-2", 
        {y: "-40", opacity: 0},
        { 
          duration: 1.8,
          delay: 1,
          y: "0",
          opacity: 1,
          ease: "power2.out"
        }
      )
      
      titleIntroPart2.fromTo(".gsap-title h1.title .title-part-1", 
        {y: "-40", opacity: 0},
        { 
          duration: 1.6,
          delay: 1.2,  // Short delay between part 2 and part 1
          y: "0",
          opacity: 1,
          ease: "power2.out"
        }
      );

    if (window.innerWidth > 1024) {
      article.fromTo(".gsap-title .article",
      {x: "40", opacity: 0},
      { 
        duration: 2,
        delay: 1.8,
        x: "0",
        opacity: 1,
        ease: "power2.out",
        stagger: 0.08     
      });
  
      event.fromTo(".gsap-title .event",
      {x: "40", opacity: 0},
      { 
        duration: 1.8,
        delay: 2,
        x: "0",
        opacity: 1,
        ease: "power2.out",
        stagger: 0.08       
      });
  
      podcast.fromTo(".gsap-title .podcast",
      {x: "40", opacity: 0},
      { 
        duration: 1.6,
        delay: 2.2,
        x: "0",
        opacity: 1,
        ease: "power2.out",
        stagger: 0.08       
      });
    }
    
  }
})
